module.exports = __webpack_public_path__ + "static/media/Vector.e684ff04.svg";